<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tit">BattleCraft: Volume 1</h1>
<h1 class="btnew">THE BATTLES <span class="btnews">of</span></h1>
<h1 class="btnew">EL ALAMEIN</h1>
<p class="stit">THE END OF THE BEGINNING</p>
<p class="bkaut">Ben Skipper</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?a83d21fe